<div class="google-test-container">
  <div class="test-header">
    <h2>🔐 Google OAuth Test Component</h2>
    <p>
      Bu component Google OAuth functionality'sini test etmek için
      oluşturulmuştur.
    </p>
  </div>

  <!-- Google Sign-In Section -->
  <div class="google-signin-section">
    <div class="config-info">
      <h3>📋 Konfigürasyon Bilgileri</h3>
      <div class="info-grid">
        <div class="info-item">
          <strong>Client ID:</strong>
          <span class="client-id">{{ googleClientId }}</span>
        </div>
        <div class="info-item">
          <strong>API URL:</strong>
          <span>{{ apiUrl }}</span>
        </div>
        <div class="info-item">
          <strong>Environment:</strong>
          <span class="env-badge" [class.prod]="!isDevelopment">
            {{ isDevelopment ? "Development" : "Production" }}
          </span>
        </div>
      </div>
    </div>

    <!-- Google Sign-In Button Container -->
    <div class="signin-container">
      <h3>🚀 Google Sign-In Test</h3>

      <!-- Automatic Google Button -->
      <div class="button-section">
        <h4>1. Otomatik Google Button</h4>
        <div id="google-signin-button" class="google-signin-button"></div>
        <p
          class="status"
          [class.success]="showGoogleButton"
          [class.error]="!showGoogleButton"
        >
          Status:
          {{
            showGoogleButton ? "Button yüklendi ✅" : "Button yüklenemedi ❌"
          }}
        </p>
      </div>

      <!-- Manual Google Button -->
      <div class="button-section">
        <h4>2. Manuel Google Button</h4>
        <button
          type="button"
          class="btn btn-google manual-btn"
          (click)="signInWithGoogle()"
          [disabled]="isLoading"
        >
          <i class="fab fa-google" *ngIf="!isLoading"></i>
          <div class="spinner" *ngIf="isLoading"></div>
          {{ isLoading ? "Yükleniyor..." : "Google ile Giriş Yap" }}
        </button>
      </div>

      <!-- Test Buttons -->
      <div class="button-section">
        <h4>3. Test İşlemleri</h4>
        <div class="test-buttons">
          <button class="btn btn-test" (click)="checkGoogleAPI()">
            🔍 Google API Kontrol Et
          </button>
          <button class="btn btn-test" (click)="testWithSampleToken()">
            🧪 Sample Token Test
          </button>
          <button class="btn btn-test" (click)="showOneTap()">
            👆 One Tap Göster
          </button>
          <button class="btn btn-test btn-clear" (click)="clearLogs()">
            🗑️ Logları Temizle
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Token Information -->
  <div class="token-section" *ngIf="lastIdToken">
    <h3>🔑 Son ID Token Bilgisi</h3>
    <div class="token-display">
      <div class="token-header">
        <strong>Token (İlk 100 karakter):</strong>
        <button class="btn btn-copy" (click)="copyToken()">📋 Kopyala</button>
      </div>
      <div class="token-content">{{ lastIdToken | slice : 0 : 100 }}...</div>
      <div class="token-length">
        Toplam uzunluk: {{ lastIdToken.length }} karakter
      </div>
    </div>

    <!-- Token Details -->
    <div class="token-details" *ngIf="tokenPayload">
      <h4>📊 Token Detayları</h4>
      <div class="payload-grid">
        <div class="payload-item">
          <strong>Email:</strong> {{ tokenPayload.email }}
        </div>
        <div class="payload-item">
          <strong>Name:</strong> {{ tokenPayload.name }}
        </div>
        <div class="payload-item">
          <strong>Sub (User ID):</strong> {{ tokenPayload.sub }}
        </div>
        <div class="payload-item">
          <strong>Email Verified:</strong> {{ tokenPayload.email_verified }}
        </div>
        <div class="payload-item">
          <strong>Issued At:</strong> {{ tokenPayload.iat | date : "medium" }}
        </div>
        <div class="payload-item">
          <strong>Expires:</strong> {{ tokenPayload.exp | date : "medium" }}
        </div>
      </div>
    </div>
  </div>

  <!-- API Response -->
  <div class="response-section" *ngIf="lastApiResponse">
    <h3>📡 API Response</h3>
    <div class="response-display">
      <div
        class="response-status"
        [class.success]="lastApiResponse.succeeded"
        [class.error]="!lastApiResponse.succeeded"
      >
        Status: {{ lastApiResponse.succeeded ? "Başarılı ✅" : "Başarısız ❌" }}
      </div>
      <div class="response-content">
        <pre>{{ lastApiResponse | json }}</pre>
      </div>
    </div>
  </div>

  <!-- Console Logs -->
  <div class="logs-section">
    <h3>📝 Console Logs</h3>
    <div class="logs-container">
      <div
        class="log-entry"
        *ngFor="let log of consoleLogs; trackBy: trackByIndex"
        [class]="log.type"
      >
        <span class="log-time">{{ log.time | date : "HH:mm:ss.SSS" }}</span>
        <span class="log-type">{{ log.type.toUpperCase() }}</span>
        <span class="log-message">{{ log.message }}</span>
      </div>
      <div *ngIf="consoleLogs.length === 0" class="no-logs">
        Henüz log kaydı yok. Google Sign-In'i test edin.
      </div>
    </div>
  </div>

  <!-- Instructions -->
  <div class="instructions-section">
    <h3>📚 Test Talimatları</h3>
    <div class="instructions">
      <ol>
        <li>
          <strong>Google API Kontrol Et:</strong> Google API'nin yüklenip
          yüklenmediğini kontrol eder
        </li>
        <li>
          <strong>Otomatik Button:</strong> Google'ın resmi button component'ini
          kullanır
        </li>
        <li>
          <strong>Manuel Button:</strong> Programmatik olarak Google Sign-In'i
          tetikler
        </li>
        <li>
          <strong>Sample Token Test:</strong> Sahte bir token ile backend
          API'sini test eder
        </li>
        <li><strong>One Tap:</strong> Google One Tap özelliğini gösterir</li>
      </ol>

      <div class="warning">
        <strong>⚠️ Önemli Notlar:</strong>
        <ul>
          <li>Bu component sadece test amaçlıdır</li>
          <li>Production'da kullanmayın</li>
          <li>Gerçek Client ID ile test edin</li>
          <li>Backend API'sinin çalıştığından emin olun</li>
        </ul>
      </div>
    </div>
  </div>
</div>
